module.exports = __webpack_public_path__ + "html/pricing_1430e0c140ee75e11913cfb80cdbd00d.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/studio/pricing.html
// module id = v+R/
// module chunks = 118